export default ({ request }) => ({

  prjDictionaryListApi (data = {}) {
    return request({
      url: '/digitalCenter/project/dictionary/list',
      method: 'post',
      data
    })
  },
  prjDictionaryDetailApi (data = {}) {
    return request({
      url: '/digitalCenter/project/dictionary/detail',
      method: 'post',
      data
    })
  },
  prjDictionarySaveApi (data = {}) {
    return request({
      url: '/digitalCenter/project/dictionary/save',
      method: 'post',
      data
    })
  },
  prjDictionaryDelApi (data = {}) {
    return request({
      url: '/digitalCenter/project/dictionary/del',
      method: 'post',
      data
    })
  }
})